import Backbone from 'backbone'
import template from './colors-test.hbs'
import fs from 'fs'
import _ from 'lodash'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import gradients from 'scoreboard/components/threshold-colors/gradients'
import dropdown from 'scoreboard/components/dropdown'
import svgGradientTemplate from './test-colors-svg-gradient.hbs'

var ColorsTestView = Backbone.View.extend({

	className: 'admin table-hack display-layout admin-test-view admin-test-colors',

	events: {
		'change select[name=gradient]': '_changeColor',
		'change input[name=valueToColor]': '_changeValueToColor'
	},

	render: function () {
		this.$el.empty().append(template())
		var colorMap = {}

		var insertColorBoxes = (colors, trigger, container) => {
			let colorArray = []
			let reading
			_.each(colors, line => {
				let startReading = line.indexOf('START: ' + trigger) > -1
				let endReading = line.indexOf('END: ' + trigger) > -1
				if ((startReading || reading) && !endReading) {
					// Extract the color name without the '$color-' prefix ($color-name => name)
					let name = line.substr(0, line.indexOf(':')).substr(7)
					// If a hex value was extracted, push that color to extendedColorPalatte.
					if (line.indexOf('#') >= 0) {
						// Extract the actual color.
						let value = line.substring(line.indexOf('#'), line.indexOf(';'))
						colorArray.push({name, value})
						// Save the color to the colorMap so we can use it later if any
						// other color vars reference it.
						colorMap[line.substr(0, line.indexOf(':'))] = value
					} else if (line.indexOf('$') >= 0) {
						// We're looking at a color which is just a reference to a previously
						// defined color. Go ahead and grab that already defined color and display it.
						let referenceColor = line.substring(line.indexOf(' $'), line.indexOf(';')).trim()
						colorArray.push({
							name,
							value: colorMap[referenceColor],
							altName: referenceColor
						})
					}

					reading = true
				} else if (endReading) {
					return false
				}
			})

			if (colorArray.length > 0) {
				_.each(colorArray, color => {
					this.$(container).append(`
						<div class="color-box">
							<div style="background: ${color.value}"></div>
							<span class="name">${color.name}</span>
							<br>
							<span class="hex">${color.altName || color.value}</span>
						</div>
					`)
				})
			}
		}

		// Lets get the base color palatte from the scoreboard-colors module
		fs.readFile(__dirname + '/./../../../node_modules/scoreboard-colors/scoreboard-colors.scss', function(error, data) {
			insertColorBoxes(data.toString().split('\n'), 'COLOR PALATTE', '.color-palatte-container')
			// Lets get the score colors from the scoreboard-colors module
			insertColorBoxes(data.toString().split('\n'), 'SCORE COLORS', '.score-colors-container')
		})

		var that = this

		// Lets get the extended palatte colors
		fs.readFile(__dirname + '/./../../../sass/variables/colors.scss', function(error, data) {
			insertColorBoxes(data.toString().split('\n'), 'EXTENDED PALATTE', '.extended-color-palatte-container')

			// Insert the background color toggle
			that._toggle = new LabeledToggle({
				options: [{
					value: 'grey',
					label: 'Grey BG'
				},{
					value: 'white',
					label: 'White BG'
				}]
			})
			that._toggle.render()
			that._toggle.on('change', a => {
				that.$('.dashboard-widget-background-colors').removeClass('grey white')
				that.$('.dashboard-widget-background-colors').addClass(a)
			})
			that.$('.dashboard-color-panel b').after(that._toggle.el)

			// Lets round up and display our widget background specific colors
			var reading
			_.each(data.toString().split('\n'), line => {
				let startReading = line.indexOf('START: DASHBOARD WIDGET COLORS') > -1
				let endReading = line.indexOf('END: DASHBOARD WIDGET COLORS') > -1
				if ((startReading || reading) && !endReading) {

					var name = line.substr(0, line.indexOf(':') - 3).substr(26)
					var isHex = line.indexOf('#') > 0
					var isRGBA = line.indexOf('rgba') > 0
					var value
					if (isHex || isRGBA) {
						if (isHex) {
							value = line.substring(line.indexOf('#'), line.indexOf(';'))
						} else {
							value = line.substring(line.indexOf(' '), line.indexOf(';')).trim()
						}

						let greyAdjusted = line.indexOf('-ga') > 0
						var createBox = function(boxValue, boxName, boxClass) {
							that.$('.dashboard-widget-background-colors').append(
								'<div class="color-box ' + boxClass + '">' +
									'<div style="background:' + boxValue + '"></div>' +
									'<span class="name">' + boxName + '</span>' +
									'<br>' +
									'<span class="hex">' + boxValue + '</span>' +
								'</div>'
							)
						}

						if (line.indexOf('translucent') > 0) {
							if (greyAdjusted) {
								// insert a solid box first for reference
								var solidValue = '#' + line.substring(line.indexOf('>') + 2, line.length)
								createBox(solidValue, name, 'solid')
								createBox(value, name, 'translucent ga')
							} else {
								createBox(value, name, 'translucent wa')
							}
						}

						if (line.indexOf('transparent') > 0) {
							if (greyAdjusted) {
								createBox(value, name, 'transparent ga')
							} else {
								createBox(value, name, 'transparent wa')
								// Insert a line break for easier viewing
								that.$('.dashboard-widget-background-colors').append('<br>')
							}
						}
					}
					reading = true
				} else if (endReading) {
					return false
				}
			})
		})

		dropdown.values('.gradientSelect', gradients.ids(), 'red')

		this.inputs = 'red'
		this.valueToColor = 50
		this._renderColorScale()

		return this
	},

	_changeColor: function(e) {
		this._changeColorVar(e, 'inputs', 'red')
		this._renderColorScale()
	},

	_changeValueToColor: function(e) {
		this._changeColorVar(e, 'valueToColor', 50)
		this._renderColorScale()
	},

	_changeColorVar: function(e, v, def) {
		let x = this.$(e.target).val()
		if (_.isEmpty(x) || _.isNil(x)) {
			x = def
		}
		this[v] = x
	},

	_renderColorScale: function() {
		function buildSvgGradient(container, colorData) {
			container.html(svgGradientTemplate({
				segments: colorData.length,
				gradient: _.map(colorData, d => { return {offset: d.threshold*100, color: d.color.formatHex()} })
			}))
		}

		let colorOnlyBox = (container, segment) => {
			let percent = Math.floor(segment.threshold * 100)
			container.append(`
				<div class="color-box">
					<div style="background: ${segment.color.formatHex()}">${percent}%</div>
				</div>
			`)
		}

		let valueToColorBox = (container, color) => {
			container.append(`
				<div class="color-box">
					<div style="background: ${color.formatHex()}">${this.valueToColor}</div>
				</div>`)
		}

		let container = this.$('.discrete-container').empty()
		let vtc = this.$('.value-to-color-container').empty()
		let svgContainer = this.$('.gradients').empty()

		let gradient = gradients.byId(this.inputs)
		if (gradient) {
			for (let segment = 2; segment < 12; segment++) {
				container.append(`<div>${segment} Segments</div>`)
				_.each(gradient.discrete(segment).intervals, segment => {
					colorOnlyBox(container, segment)
				})
			}
			let continuous = gradient.continuous()
			valueToColorBox(vtc, continuous.valueToColor(this.valueToColor))
			buildSvgGradient(svgContainer, continuous.intervals)
		}
	}

})

export default ColorsTestView
